<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">

  <label for="name">Name: </label>
  <input id="name" type="text" formControlName="name">

  <!-- <label for="photo">Photo: </label>
  <app-upload-control formControlName="photo" title="Some media field"></app-upload-control> -->
  <p>Complete the form to enable button.</p>
  <button type="submit" [disabled]="!profileForm.valid">Submit</button>
</form>